export const messages = {
  actionMenuAria: {
    id: 'admin/promotions.commons.actions',
  },
}
